import { render, staticRenderFns } from "./member-register-settle.vue?vue&type=template&id=740c8e36&scoped=true&"
import script from "./member-register-settle.vue?vue&type=script&lang=js&"
export * from "./member-register-settle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740c8e36",
  null
  
)

export default component.exports